import { makeStyles } from '../styles';
import { resolveThemeColorByPath } from '../utils/resolveThemeColorByPath';

export const useStyles = makeStyles([
  [
    'message',
    (theme, [_, visible]) => [
      `
			display: flex;
			align-items: center;
			position: fixed;
			top: 0;
			left: 50%;
			transform: translate(-50%, -200%);
			overflow: hidden;
			margin-top: 20px;
			border-radius: 4px;
			padding: 10px 16px;
			box-shadow: 0 0 8px 0 rgba(69, 69, 69, 0.5);
			background-color: ${theme.color.text.white};
			transition: transform 200ms ease-out;
			z-index: 2000;
		`,
      visible &&
        `
			transform: translate(-50%, 0);
		`
    ]
  ],
  [
    'icon',
    (theme, [type]) => `
		font-size: 18px;
		margin-right: 10px;
		color: ${resolveThemeColorByPath(theme, type)};
	`
  ],
  [
    'content',
    `
		font-size: 14px;
		margin-right: auto;
		max-width: 80vw;
		word-break: keep-all;
		white-space: nowrap;
	`
  ],
  [
    'close',
    theme => `
		font-size: 14px;
		line-height: 1;
		color: ${theme.color.text.B};
		margin-left: 10px;
		cursor: pointer;
		user-select: none;

		&:hover {
			color: ${theme.color.text.B4};
		}
	`
  ]
]);
